// ─────────────────────────────────────────────────────────────
// EDIT THIS FILE to update your personal details across the site.
// ─────────────────────────────────────────────────────────────

export const SITE = {
  name: "AVISHI",
  fullName: "Avishi Vardhan",
  title: "Freelance Web Developer",
  email: "avishi.v.2007@gmail.com",
  whatsappUrl: "https://wa.me/919811018013",
  whatsappDisplay: "+91 98110 18013",
  startingPrice: "₹25,000",
};

export const PROJECTS = [
  {
    number: "01",
    name: "ÉLAN STUDIO",
    category: "Beauty / Salon",
    description:
      "A refined, modern digital experience created for a premium beauty studio.",
    services: ["Custom Design", "Responsive Development", "Interactive UI"],
    demoUrl: "https://luxury-salon-preview-46.emergent.host",
    image: "/projects/elan-studio.jpg", // replace with your own screenshot
  },
  {
    number: "02",
    name: "THE MIDNIGHT GARDEN",
    category: "Hospitality / Café",
    description:
      "A dark, atmospheric website concept created for a botanical-themed café.",
    services: ["Custom Design", "Responsive Development", "Interactive UI"],
    demoUrl: "https://midnight-garden-2.emergent.host",
    image: "/projects/midnight-garden.jpg", // replace with your own screenshot
  },
  {
    number: "03",
    name: "FORGE ATHLETICS",
    category: "Fitness / Wellness",
    description:
      "A bold, performance-focused digital experience for a modern fitness studio.",
    services: ["Custom Design", "Responsive Development", "Interactive UI"],
    demoUrl: "https://forge-training-hub-1.emergent.host",
    image: "/projects/forge-athletics.jpg", // replace with your own screenshot
  },
];

export const NAV_LINKS = [
  { label: "Work", href: "#work" },
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];
